export { default as SliderReviews } from './SliderReviews';
